// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2qTJo","tab":"ProcedureTabs_tab__VfLFO"};